import React from "react";
import { Typography } from "antd";
import SupportPageLayout from "./SupportPageLayout";

const { Paragraph } = Typography;

const TermsOfService = () => {
  const appName = window.location.href.includes("pharma") ? "Pharma ERP" : "Forth ERP";

  return (
    <SupportPageLayout title="Terms of Service">
      <Paragraph className="supportText" ><strong>1. Use of Service:</strong> You must be 18+ to use this service.</Paragraph>
      <Paragraph className="supportText" ><strong>2. Privacy:</strong> Data handled under Privacy Policy.</Paragraph>
      <Paragraph className="supportText" ><strong>3. Prohibited:</strong> No unlawful or abusive use.</Paragraph>
      <Paragraph className="supportText" ><strong>4. Modifications:</strong> Terms may change anytime.</Paragraph>
      <Paragraph className="supportText" ><strong>5. Termination:</strong> Access may be suspended if terms are violated.</Paragraph>
    </SupportPageLayout>
  );
};

export default TermsOfService;
